/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

export interface ICheckoutTermsAndConditionsErrorMessageProps {
    message?: string;
}

/**
 * AddPaymentForm SFC.
 * @param root0
 * @param root0.message
 * @extends {React.FC<ICheckoutTermsAndConditionsErrorMessageProps>}
 */
const CheckoutTermsAndConditionsErrorMessage: React.FC<ICheckoutTermsAndConditionsErrorMessageProps> = ({ message }) => {
    if (!message) {
        return null;
    }

    return <p className='ms-checkout-terms-and-conditions__error-message'>{message}</p>;
};

export default CheckoutTermsAndConditionsErrorMessage;
